import config from '@ui-furniture/config';
import { createService } from '@ui-furniture/lib/get-address';

export const getAddressService = createService(config.addressLookupApiKey);
